export enum PaymentTypes {
    None = 'none',
    Card = 'card',
    Cash = 'cash',
    Chip = 'chip',
    // Interest free credit (IFC).
    IFC = 'IFC'
}